import { ChangeEvent, ReactNode } from 'react';
import * as React from 'react';

import { defaultTheme } from '@/utility/theme';

import { RadioLabel, RadioWrapper, StyledRadio } from './style';

export type RadioProps = {
  children?: ReactNode;
  htmlFor: string;
  name: string;
  value?: string;
  role?: string;
  margin?: keyof typeof defaultTheme.spacing;
  checked?: boolean;
  disabled?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Radio: React.FC<RadioProps> = ({
  children,
  htmlFor,
  name,
  value,
  role,
  margin = 'xs',
  checked,
  disabled,
  onChange,
}) => {
  return (
    <RadioWrapper>
      <StyledRadio
        type="radio"
        id={htmlFor}
        name={name}
        value={value}
        role={role}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <RadioLabel htmlFor={htmlFor} disabled={disabled} margin={margin}>
        {children}
      </RadioLabel>
    </RadioWrapper>
  );
};

export default Radio;
